import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { ThemeProvider } from "@mui/material/styles";
import { theme } from "./theme/theme";
import * as Sentry from "@sentry/react";
import { ErrorBoundary } from "@sentry/react";

if (process.env.REACT_APP_ENV === "production" && process.env.REACT_APP_SENTRY_DSN) {
  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_DSN,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration(),
    ],
    tracesSampleRate: 1.0,
    tracePropagationTargets: [process.env.REACT_APP_API_URL,  /^https:\/\/yourserver\.io\/api/],
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
  });

  window.onerror = (message, error) => {
    Sentry.captureException(error || new Error(message));
  };

  // Capture unhandled promise rejections
  window.onunhandledrejection = (event) => {
    Sentry.captureException(event.reason);
  };
}

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <ErrorBoundary fallback={<p>Something went wrong.</p>}>
        <App />
      </ErrorBoundary>
    </ThemeProvider>
  </React.StrictMode>
);